const prefixAlgoEstimationShow = (algoCode: string) => {
  const regexValidationPrefix = new RegExp(/^AS|^AP|^ARA|^ARB/);
  return regexValidationPrefix.test(algoCode);
};
export default prefixAlgoEstimationShow;
